<template>
    <main class="main services">
        <div class="container">
            <header-tabs
                :content="headerTabs"
                :activeTab="activeTab"
                @changeTab="changeTab"
            />
            <div class="row">
                <the-filters
                    class="col-md-3"
                    @applyFilters="applyFilters"
                    :filters="filters"
                    :moduleName="'settlements'"
                    @clearFilters="onFiltersClear"
                />

                <div class="col-md-9">
                    <div class="c-settings">
                        <div class="c-settings-count">
                            <span v-if="settlementsStatus === 'idle'">
                                {{
                                    totalRecords
                                        | plurals('wynik', 'wyniki', 'wyników')
                                }}
                            </span>
                            <div
                                class="
                                    d-md-none
                                    form-check form-check-inline
                                    ml-3
                                "
                            >
                                <div class="custom-control custom-checkbox">
                                    <ui-checkbox-input
                                        name="selectAllPromos"
                                        v-model="selectAllData"
                                        label="Zaznacz wszystkie"
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            class="c-settings-filters mt-2 mt-md-0"
                            v-if="settlements && settlements.length > 0"
                        >
                            <div class="d-block ml-3">
                                <results-per-page
                                    :per-page="perPage"
                                    :text="'Pokazuj na stronie:'"
                                    :on-change="changeResultsPerPage"
                                ></results-per-page>
                            </div>
                            <div class="d-block ml-3">
                                <sort-component
                                    :text="'Sortuj po:'"
                                    :moduleName="'settlements'"
                                    :options="
                                        $store.getters.getSettlementsSortOptions
                                    "
                                ></sort-component>
                            </div>
                        </div>
                    </div>
                    <selected-filters
                        :filters="filters"
                        :moduleName="'settlements'"
                        @applyFilters="applyFilters"
                    />

                    <div
                        class="d-flex justify-content-between flex-wrap"
                        v-if="settlements && settlements.length > 0"
                    >
                        <span class="dropdown mr-4">
                            <button
                                class="btn btn-secondary"
                                type="button"
                                id="dropdownDownloadNotes"
                                data-toggle="dropdown"
                                @click="showDropdown = !showDropdown"
                                v-click-outside="hideDropdown"
                            >
                                {{
                                    this.activeTab === 1
                                        ? 'Pobierz dokumenty ponownie'
                                        : 'Pobierz dokumenty'
                                }}
                                <a-icon icon="Dropdown" />
                            </button>

                            <div
                                class="dropdown-menu dropdown-menu-left"
                                :class="{ show: showDropdown }"
                                aria-labelledby="dropdownDownloadNotes"
                            >
                                <button
                                    class="dropdown-item"
                                    type="button"
                                    @click="
                                        downloadSettlements(`Report`, 'filters')
                                    "
                                >
                                    Rozliczeniowe - xls
                                </button>
                                <button
                                    class="dropdown-item"
                                    type="button"
                                    @click="
                                        downloadSettlements(
                                            `Report`,
                                            'last_month'
                                        )
                                    "
                                >
                                    Rozliczeniowe - xls (ostatni miesiąc)
                                </button>
                                <button
                                    class="dropdown-item"
                                    type="button"
                                    @click="
                                        downloadSettlements(`Note`, 'filters')
                                    "
                                >
                                    Księgowe - pdf
                                </button>
                                <button
                                    class="dropdown-item"
                                    type="button"
                                    @click="
                                        downloadSettlements(
                                            `Note`,
                                            'last_month'
                                        )
                                    "
                                >
                                    Księgowe - pdf (ostatni miesiąc)
                                </button>
                            </div>
                        </span>
                    </div>

                    <div class="content mt-4">
                        <div class="d-flex align-items-center">
                            <div class="flex-grow-1 pb-3 text-sm">
                                Pobrane dokumenty trafiają do zakładki pobrane
                                rozliczenia.
                            </div>
                            <div
                                class="c-promos-all text-right d-none d-md-block"
                                v-if="settlements && settlements.length > 0"
                            >
                                <div
                                    class="
                                    form-check form-check-inline
                                    pr-3
                                    mr-1
                                    mb-3
                                "
                                >
                                    <div class="custom-control custom-checkbox">
                                        <ui-checkbox-input
                                            name="selectAllPromos"
                                            v-model="selectAllData"
                                            label="Zaznacz wszystkie"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="c-table notesTable">
                            <div class="c-tbody">
                                <page-preloader
                                    v-if="settlementsStatus === 'loading'"
                                ></page-preloader>
                                <settlement-preview
                                    v-else
                                    v-for="(settlement, idx) in settlements"
                                    :key="idx"
                                    :data="settlement"
                                    @settlementDownload="
                                        settlementDownloadMethod
                                    "
                                ></settlement-preview>
                            </div>
                        </div>
                    </div>
                    <the-pagination
                        v-if="current <= total"
                        :current="current"
                        :total="total"
                        :perPage="perPage"
                        :on-change="onChange"
                    >
                        <results-per-page
                            :per-page="perPage"
                            :text="'Pokazuj na stronie:'"
                            :on-change="changeResultsPerPage"
                        ></results-per-page>
                    </the-pagination>
                </div>
            </div>
        </div>
        <settlements-bar
            v-if="selectedSettlements.length > 0"
            :data="selectedSettlements"
        ></settlements-bar>
    </main>
</template>

<script>
import SettlementPreview from '@/components/settlements/SettlementPreview'
import SettlementsBar from '@/components/settlements/SettlementsBar'
import { UiCheckboxInput } from '../components/global/ui'

export default {
    data() {
        return {
            headerTabs: [
                {
                    text: 'Rozliczenia do pobrania',
                    link: '#',
                    hash: '#available'
                },
                {
                    text: 'Pobrane rozliczenia',
                    link: '#',
                    hash: '#downloaded',
                    counter: 0
                }
            ],
            showDropdown: false
        }
    },
    components: {
        SettlementPreview,
        SettlementsBar,
        UiCheckboxInput
    },

    watch: {
        downloadedBundleProgressBar(value) {
            if (value && value.finished) {
                if (
                    value.bundle_document_type === 'Note' &&
                    this.activeTab === 0
                ) {
                    this.fetch()
                }
                this.onSettlementsSuccessfullyDownload(
                    value.bundle_document_type === 'Note'
                        ? 'settlement'
                        : 'settlement_report'
                )
            }
        },
        settlementsDownloadCounter: {
            immediate: true,
            handler(val) {
                this.headerTabs[1].counter = val
            }
        }
    },
    computed: {
        settlementsDownloadCounter() {
            return this.$store.getters.getSettlementsDownloadCounter
        },
        downloadedBundleProgressBar() {
            return this.$store.getters.getSettlementsProgressBar
        },
        current() {
            return this.$store.getters.getSettlementsCurrent
        },
        total() {
            return this.$store.getters.getSettlementsTotalPages
        },
        perPage() {
            return this.$store.getters.getSettlementsPagination.perPage
        },
        settlements() {
            return this.$store.getters.getSettlements
        },
        totalRecords() {
            return this.$store.getters.getSettlementsTotalRecords
        },
        settlementsStatus() {
            return this.$store.getters.getSettlementsStatus
        },
        selectedSettlements() {
            return this.$store.getters.getSelectedSettlements
        },
        filters() {
            return this.$store.getters.getSettlementsFilters
        },
        activeTab: {
            get() {
                return this.$store.getters.getSettlementsActiveTab
            },
            set(value) {
                this.$store.dispatch('setSettlementsDefaultFilters')
                this.$store.dispatch('selectAllSettlements', false)
                this.$store.dispatch('setSettlementsActiveTab', value)
            }
        },
        selectAllData: {
            get() {
                return this.$store.getters.getSettlementsSelectAll
            },
            set(value) {
                this.$store.dispatch('selectAllSettlements', value)
            }
        }
    },
    methods: {
        onSettlementsSuccessfullyDownload(type) {
            this.$store.dispatch('addNotification', {
                code: 'settlementsDownload',
                onlyOneAllowed: true,
                type: 'success',
                duration: 30000,
                content: `${
                    type === 'settlement_report'
                        ? 'Raport rozliczeniowy został pobrany'
                        : this.activeTab === 0
                            ? 'Pobrane dokumenty zostały przeniesione do zakładki "Pobrane"'
                            : 'Dokument księgowy został pobrany'
                }`
            })
            this.$store.dispatch('selectAllSettlements', false)
        },
        onFiltersClear() {
            const isDownloadedTab = this.activeTab === 1
            this.$store.dispatch('setSettlementsFilters', { isDownloadedTab })
            this.$store.dispatch('setSettlementsDefaultFilters')
        },
        async settlementDownloadMethod(data) {
            let url = `settlements/other_documents_individual/${data.id}/`

            url +=
                data.type === 'settlement'
                    ? 'document?mark_as_exported=true'
                    : 'report'
            data.url = url

            await this.$store.dispatch('downloadSettlement', data)
            if (this.activeTab === 0 && data.type === 'settlement') {
                this.fetch()
            }

            this.onSettlementsSuccessfullyDownload(data.type)
        },
        changeTab(value) {
            this.activeTab = value
        },
        applyFilters() {
            this.fetch()
        },
        async fetch() {
            this.$store.dispatch('settlementsFetch')
        },
        onChange(page) {
            return this.$router.push({
                query: { ...this.$route.query, page: page }
            })
        },
        changeResultsPerPage(value) {
            return this.$router.push({
                query: { ...this.$route.query, show: value, page: 1 }
            })
        },
        downloadSettlements(bundleType, downloadType) {
            this.$store.dispatch('downloadSettlements', {
                downloadType: downloadType,
                bundleType: bundleType
            })
            this.hideDropdown()
        },
        hideDropdown() {
            this.showDropdown = false
        }
    },
    created() {
        this.$store.dispatch('fetchParametrizationDocumentTypes')
        this.$store.dispatch('setSettlementsDefaultFilters')
    },
    mounted() {
        const isDownloadedTab = this.activeTab === 1

        this.$store.dispatch('setSettlementsFilters', {
            isDownloadedTab
        })
        if (isDownloadedTab) {
            this.$store.dispatch('setDownloadedSettlementsCounter', 0)
        }

        this.fetch()
    }
}
</script>
